import { Box, Typography } from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import useIsSmallMobile from '../../../custom-hooks/useIsSmallMobile';
import { bgColor, primaryColor, textColor } from '../../../utils/themeColor';
import type { Transcription } from '../../../api/types';

const RecordCard = ({ transcription }: { transcription: Transcription }) => {
  const smMobile = useIsSmallMobile();
  const navigate = useNavigate();

  const handleViewDetails = () => {
    navigate('/file-details', {
      state: {
        record_number: transcription.record_number,
        id: transcription.transcription_id,
        summary: transcription.summary,
        transcription_text: transcription.transcription_text,
      },
    });
  };

  return (
    <Box sx={{ mx: 'auto' }}>
      <Box
        sx={{
          backgroundColor: bgColor,
          width: '100%',
          minHeight: '100px',
          borderTopRightRadius: '20px',
          borderBottomRightRadius: '20px',
          borderRadius: { xs: 'none', sm: '30px' },
          marginTop: '20px',
        }}
      >
        <Box
          sx={{
            py: '10px',
            pl: { xs: smMobile ? '25px' : '35px', sm: '100px' },
            pr: { xs: '15px', sm: '0px' },
          }}
        >
          <Typography component="p" sx={{ fontSize: '13px' }}>
            ID: {transcription.transcription_id}
          </Typography>
          <Typography
            component="p"
            sx={{
              fontSize: '15px',
              fontWeight: 'bold',
              color: textColor,
              lineHeight: '14px',
            }}
          >
            {`Recording # ${transcription.record_number}`}
          </Typography>
          <Typography component="p" sx={{ fontSize: '14px' }}>
            Sentiment: {transcription.sentiment}
          </Typography>
          <Typography component="p" sx={{ fontSize: '14px', lineHeight: '14px' }}>
            Summary: &ldquo;
            {transcription.summary.length > 80
              ? `${transcription.summary.substring(0, 80)}...`
              : transcription.summary}
            &rdquo;
          </Typography>
          <Typography
            component="p"
            onClick={handleViewDetails}
            sx={{
              fontSize: '15px',
              fontWeight: 'bold',
              color: primaryColor,
              cursor: 'pointer',
            }}
          >
            View Details
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default RecordCard;
